module.exports = __webpack_public_path__ + "static/media/arrowUp.5a9b311a.svg";